// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import echarts from 'echarts';
// 引入EXCEL导出依赖
import JsonExcel from 'vue-json-excel';
import App from './App.vue';
import router from './router';
import store from '../store';
import 'element-ui/lib/theme-chalk/index.css';
import { preventReClick } from '@/assets/plugin/preventReClick/preventReClick';// 防多次点击，重复提交
// 引入自定义插件
import Message from './assets/plugin/message/message';
import util from './assets/common/util';
import './assets/css/orderDetail.css';
import tooltipButton from './components/base/tooltipButton';
import uploadExcelToJson from '@/components/base/uploadExcelToJson.vue';
import downloadJsonToExcel from '@/components/base/downloadJsonToExcel.vue';
import limitUpload from '@/components/base/limitUpload.vue';
import globleMixin from './assets/common/mixins/globleMixin';


Vue.component('downloadExcel', JsonExcel);
Vue.component('tooltipButton', tooltipButton);
Vue.component('uploadExcelToJson', uploadExcelToJson);
Vue.component('downloadJsonToExcel', downloadJsonToExcel);
Vue.component('limitUpload', limitUpload);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Message);
Vue.use(preventReClick);
Vue.prototype.$echarts = echarts;
Vue.prototype.$util = util;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  mixins: [globleMixin],
  template: '<App/>',
});
// 路由前置守卫
router.beforeEach((to, from, next) => {
  if (['/', '/loginEditPass', '/forget'].includes(to.path)) {
    next();
  } else if (!sessionStorage.getItem('userId') || sessionStorage.getItem('登录系统') != 'SCM') {
    next({ path: '/' });
  } else {
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js